import * as React from "react";
import type { SVGProps } from "react";
const SvgHotkeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="hotkey_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M71.168 213.333A85.333 85.333 0 0 1 156.501 128h711.126a85.333 85.333 0 0 1 85.333 85.333v597.334A85.333 85.333 0 0 1 867.627 896H156.5a85.333 85.333 0 0 1-85.333-85.333V213.333zm796.459 0H156.5v597.334h711.126V213.333zm-568.96 227.584a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm0 170.667a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128-128a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM640 440.917a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zm42.667 128a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm-384-42.667a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667z"
    />
  </svg>
);
export default SvgHotkeyIcon;
